import { registerPlugin, WebPlugin } from '@capacitor/core';

import type {
  LiveUpdateConfig,
  LiveUpdateResult,
  SyncResult,
} from './definitions';

interface LiveUpdatesPlugin {
  /**
   * Sync the app with Live Updates
   */
  sync(
    options: unknown,
    callback: (result: { progress: number } | LiveUpdateResult) => void,
  ): Promise<string>;
  setConfig(config: LiveUpdateConfig): Promise<void>;
  getConfig(): Promise<LiveUpdateConfig>;
  resetConfig(): Promise<void>;
  reload(): Promise<void>;
}

const LiveUpdates = registerPlugin<LiveUpdatesPlugin>('LiveUpdates', {
  web: () => new LiveUpdatesWeb(),
});

export const sync = async (
  progress: ((percentage: number) => void) | undefined = undefined,
): Promise<SyncResult> => {
  return new Promise((resolve, reject) => {
    LiveUpdates.sync({}, (result: { progress: number } | LiveUpdateResult) => {
      if ('progress' in result) {
        if (progress) {
          progress(result.progress);
        }
      } else if ('failStep' in result) {
        reject(result);
      } else {
        resolve(result);
      }
    });
  });
};

export const setConfig = async (config: LiveUpdateConfig): Promise<void> => {
  return LiveUpdates.setConfig(config);
};

export const getConfig = async (): Promise<LiveUpdateConfig> => {
  return LiveUpdates.getConfig();
};

export const resetConfig = async (): Promise<void> => {
  return LiveUpdates.resetConfig();
};

export const reload = async (): Promise<void> => {
  return LiveUpdates.reload();
};

class LiveUpdatesWeb extends WebPlugin implements LiveUpdatesPlugin {
  async sync(
    _options: unknown,
    callback: (result: { progress: number } | LiveUpdateResult) => void,
  ): Promise<string> {
    callback({
      failStep: 'CHECK',
      message: 'Not implemented for web only',
    });
    return '';
  }

  /* eslint-disable */
  //@ts-ignore
  async setConfig(config: LiveUpdate): Promise<void> {}
  async getConfig(): Promise<LiveUpdateConfig> {
    return {};
  }
  async resetConfig(): Promise<void> {}
  async reload(): Promise<void> {}
  /* eslint-enable */
}

export * from './definitions';
